import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import ReportAndon from "../Reports/reportAndonAction";
import ReportOEE from "../Reports/reportOEE";
import ReportRefuses from "../Reports/reportRefuses";
import ReportStops from "../Reports/reportStops";
import ReportOeeWorkShift from "../Reports/reportOeeWorkShift";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import "./prelude.css";
import BottomBar from "../../Components/bottomBar/bottomBar";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";
import Api from "../../services/api";
import {handleColor} from '../../services/Functions';
import { Redirect } from "react-router-dom";
class Sidebar extends React.Component {
  state = { data: [], render: false, redirect: false, click: false };


  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

 

  render() {
    const { redirect } = this.state;

    if (redirect) return <Redirect to="/relatorios"></Redirect>;

    return (
      <Tab.Container defaultActiveKey="stops">
        <Row style={{width:'100%',height:'100%'}}>
          <div className="sidebar1">
            <div className="sidebar2">
              <Col className="sidebarColumn">
              <ListGroup>
                  <ListGroup.Item
                    onClick={handleColor}
                    id="lg1"
                    action
                    eventKey="stops"
                    style={{
                        backgroundColor: "#05ca83",
                        color: "#fff",
                        border: "none",
                      }}
                  >
                    Histórico de Paradas
                  </ListGroup.Item>
                  <ListGroup.Item
                    onClick={handleColor}
                    id="lg2"
                    action
                    eventKey="refuses"
                  >
                    Histórico de Refugos
                  </ListGroup.Item>
                  <ListGroup.Item
                    onClick={handleColor}
                    id="lg3"
                    action
                    eventKey="oee"
                  >
                    Apontamentos
                  </ListGroup.Item>
                  <ListGroup.Item
                    onClick={handleColor}
                    id="lg4"
                    action
                    eventKey="andon"
                  >
                    Andon
                  </ListGroup.Item>
                  <ListGroup.Item
                    onClick={handleColor}
                    id="lg5"
                    action
                    eventKey="oeeWorkShift"
                  >
                    OEE x Turno
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </div>
            <Col className='col3' style={{ top: "5%", marginLeft: "1.5%", width: "100%",height:'78vh', overflow:'auto' }}>
              <Tab.Content>
                <Tab.Pane className='col5' mountOnEnter unmountOnExit eventKey="stops">
                  {this.handleClick ? <ReportStops/> : null}
                </Tab.Pane>
                <Tab.Pane className='col5' mountOnEnter unmountOnExit eventKey="refuses">
                  {this.handleClick ? <ReportRefuses/> : null}
                </Tab.Pane>
                <Tab.Pane className='col5' mountOnEnter unmountOnExit eventKey="oee">
                  {this.handleClick ? <ReportOEE/> : null}
                </Tab.Pane>
                <Tab.Pane className='col5' mountOnEnter unmountOnExit eventKey="andon">
                  {this.handleClick ? <ReportAndon/> : null}
                </Tab.Pane>
                <Tab.Pane className='col5' mountOnEnter unmountOnExit eventKey="oeeWorkShift">
                  {this.handleClick ? <ReportOeeWorkShift/> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

function prelude_reports() {
  return (
    <>
      <div>
        <Top_bar title="Relatórios" />{" "}
      </div>
      <div className="prelude_container">
        <Sidebar></Sidebar>
      </div>
      <footer>
        <BottomBar></BottomBar>
      </footer>
    </>
  );
}

export default prelude_reports;